import React from "react";

const EmptyStateIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="20"
    fill="none"
    viewBox="0 0 22 20"
  >
    <path
      fill="#002564"
      fillOpacity="0.3"
      d="M20.47 19.53a.75.75 0 1 0 1.06-1.06zM18.6 16.6l-.53.53 2.4 2.4L21 19l.53-.53-2.4-2.4zm1.2-4.2h.75a6.15 6.15 0 0 0-6.15-6.15v1.5a4.65 4.65 0 0 1 4.65 4.65zM14.4 7v-.75a6.15 6.15 0 0 0-6.15 6.15h1.5a4.65 4.65 0 0 1 4.65-4.65zM9 12.4h-.75a6.15 6.15 0 0 0 6.15 6.15v-1.5a4.65 4.65 0 0 1-4.65-4.65zm5.4 5.4v.75a6.15 6.15 0 0 0 6.15-6.15h-1.5a4.65 4.65 0 0 1-4.65 4.65z"
    ></path>
    <path
      stroke="#002564"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity="0.3"
      strokeWidth="1.5"
      d="M1 8h5M1 15h5M1 1h17"
    ></path>
  </svg>
);

export default EmptyStateIcon;
